import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom'

import NeedHelp from '../../components/need-help'

import { getSS, setSS, renderDate, loadIndexPage } from '../../helpers'

const Intro: React.FC = (props: any) => {

  const navigate = useNavigate()
  const params = useParams()
  const [ dataLayerInitialPush2, setDataLayerInitialPush2] = useState(getSS('dataLayerInitialPush2'))
  const appeal = (window as any).KEW.collections.appeal[0]
  const url = params.url
  const donation = getSS('donation')

  if (!donation.amount) {
    loadIndexPage(navigate, url)
  }

  useEffect(() => {
    document.title = 'Thank you - ' + (window as any).KEW.collections.appeal[0].meta_page_title
  })

  useEffect(() => {
    document.body.classList.add('thankyou')
    document.body.style.backgroundImage = `url(${appeal.thankyou_page_background})`;


    if (!dataLayerInitialPush2) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'purchase',
        ecommerce: {
          currency: 'GBP',
          value: donation.amount,
          transaction_id: donation.id,
          payment_type: donation.payment_method,
          items: [{
            item_name: `Donation - ${appeal.name}`,
            item_id: appeal.campaigncode,
            price: donation.amount,
            item_brand: 'Kew',
            item_category: donation.payment_type === 'Single' ? 'single' : 'monthly',
            item_category3: `Gift Aid - ${donation.optins_giftaid ? 'Yes' : 'No'}`,
            quantity: 1
          }]
        }
      });
      setSS('dataLayerInitialPush2', true)
      setDataLayerInitialPush2(true)
    }
  }, [appeal.thankyou_page_background, appeal.name, donation, appeal.campaigncode, dataLayerInitialPush2])

  useEffect(() => {
    (window as any).addEventListener('beforeunload', function (e: any) {
      e.preventDefault();
      sessionStorage.removeItem('donation')
    })
  }, [])

  return (
    <>
      { donation &&
        <>
          <div className="row intro">
            <div className="large-12 columns box">
              <div className="intro-copy">
                <h1>{appeal.thank_you_page_title}</h1>
              </div>
            </div>
          </div>

          <div className="row intro-divider hide-for-small"></div>

          <div className="row box thanks">
            <div className="row">
              <div className="medium-7 columns">
                <div className="mobile-image show-for-small-only">
                  <img src={appeal.thank_you_mobile_image} alt={appeal.thank_you_image_alt} />
                  { appeal.thank_you_image_credit &&
                    <span className="credit">{appeal.thank_you_image_credit}</span>
                  }
                </div>
                { getSS('donation').payment_type === 'Single' &&
                  <div dangerouslySetInnerHTML={{ __html: appeal.single_thank_you_intro}}></div>
                }
                { getSS('donation').payment_type === 'Regular' &&
                  <div dangerouslySetInnerHTML={{ __html: appeal.regular_thank_you_intro}}></div>
                }
                <div className="donation-details">
                  <p>Donation amount: <b>£{(getSS('donation').amount).toFixed(2)}</b></p>
                  { getSS('donation').payment_type === 'Single' &&
                    <p>Payment reference: <b>{donation.id}</b></p>
                  }
                </div>
                <img src="/assets/default/images/giftaid.png" alt="Gift Aid Logo" className="logo"/>
                { getSS('donation').optins_giftaid &&
                  <p>Thank you too for signing up to Gift Aid, which means your donation will go even further in supporting our work.</p>
                }
                { !getSS('donation').optins_giftaid &&
                  <p>Your donation of <span className="robo-b">£{(donation.amount).toFixed(2)}</span> { getSS('donation').payment_type === 'Regular' && <span> per month </span> } would be worth an extra <span className="robo-b">£{(getSS('donation').amount*.25).toFixed(2)}</span> { getSS('donation').payment_type === 'Regular' && <span> per month </span> } if we were able to claim Gift Aid on it. Please consider making a Gift Aid declaration by speaking to our Supporter Care team using the details shown - it can make a considerable difference to the amount of money we raise.</p>
                }
                { getSS('donation').payment_type === 'Single' &&
                  <div className="divider"></div>
                }
                <p>Thank you again for your generosity.</p>
              </div>
              <div className="medium-5 large-4 columns">
                <div className="mobile-divider show-for-small-only"></div>
                <NeedHelp />
              </div>
            </div>
            <div className="row">
              <div className="medium-12 columns">
                { donation.payment_type === 'Regular' &&
                  <div className="ddGuarantee clearfix box">
                    <div className="row">
                      <div className="large-12 columns">
                        <section id="ddInstruction">
                          <span className="icon-dd-logo"></span>
                          <h2 className="dd">Direct Debit Instruction</h2>
                          <p>Please print off and retain for your records</p>
                          <div className="row">
                            <div className="large-6 columns">
                              <p className="strong"><span className="larger block">The Royal Botanic Gardens, Kew</span>Royal Botanic Gardens, Kew, Richmond, Surrey TW9 3AE</p>
                              <p className="nbm">Name(s) of Account Holder(s):</p>
                              <p className="strong">{donation.bank_account_account_name}</p>
                              <p className="nbm">Bank / building society Account Number:</p>
                              <p className="strong">{donation.bank_account_number_redacted}</p>
                              <p className="nbm">Branch Sort Code:</p>
                              <p className="strong">{donation.bank_account_sort_code}</p>
                              <p className="nbm">Name and full postal address of your bank or building society:</p>
                              <p className="strong validated-bank-details">
                                <span>{donation.validated_dd_bank_name}</span>
                                <span>{donation.validated_dd_bank_address1}</span>
                                <span>{donation.validated_dd_bank_address2}</span>
                                <span>{donation.validated_dd_bank_town}</span>
                                <span>{donation.validated_dd_bank_postcode}</span>
                                {/* <span className="address-key"></span> ng-repeat="key in dd_address_keys" {{donation[key]}} */}
                              </p>
                            </div>
                            <div className="large-6 columns">
                              <p>Instruction to your bank or building society to pay by Direct Debit</p>
                              <p className="strong">Service user number: {donation.bacs_sun}</p>
                              <p className="strong">Instruction to your bank or building society:</p>
                              <p className="strong">Please pay Royal Botanic Gardens, Kew Direct Debits from the account detailed in this Instruction subject to the safeguards assured by the Direct Debit Guarantee. I understand that this instruction may remain with Royal Botanic Gardens, Kew and, if so, details will be passed electronically to my bank/building society.</p>
                              <p className="strong">Date: {renderDate(donation.date_created)}</p>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                }
                { donation.payment_type === 'Regular' &&
                  <div className="ddGuarantee clearfix box">
                    <div className="large-12 columns">
                      <p>The Royal Botanic Gardens, Kew will set up a Direct Debit from the account detailed in this instruction subject to the safeguards assured by the Direct Debit Guarantee.</p>
                      <span className="icon-dd-logo"></span>
                      <h2 className="dd">The Direct Debit Guarantee</h2>
                      <ul>
                        <li>This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.</li>
                        <li>If there are any changes to the amount, date or frequency of your Direct Debit Royal Botanic Gardens, Kew will notify you 5 working days in advance of your account being debited or as otherwise agreed. If you request Royal Botanic Gardens, Kew to collect a payment, confirmation of the amount and date will be given to you at the time of the request.</li>
                        <li>If an error is made in the payment of your Direct Debit, by Royal Botanic Gardens, Kew or your bank or building society you are entitled to a full and immediate refund of the amount paid from your bank or building society. If you receive a refund you are not entitled to, you must pay it back when Royal Botanic Gardens, Kew asks you to.</li>
                        <li>In the event Royal Botanic Gardens, Kew are unsuccessful collecting a payment, we may attempt a second collection within 31 days.</li>
                        <li>You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify us on +44 (0)208 332 3248.</li>
                      </ul>
                    </div>
                  </div>
                }
                <p>Please consider sharing news of your donation online with your family, friends and colleagues.</p>
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${appeal.facebook_share}`} className="btn-share fb" target="_blank" rel="noreferrer"><span className="icon-fb">Facebook</span></a>
                <a href={`http://twitter.com/intent/tweet?text=${appeal.twitter_share}`} className="btn-share tw" target="_blank" rel="noreferrer"><span className="icon-tw">Twitter</span></a>
                {/* // a.btn-share.in target="_blank" href="https://www.linkedin.com/shareArticle?mini=true&url={{appeal.linkedin_share}}" <span className="icon-in">LinkedIn</span> */}
                </div>
              </div>
            </div>
        </>
      }
    </>
  );
};

export default Intro;